import {Counter} from "store/dashboard/DashboardStore"

function calculatePercent(ttl: number, val: number) {
    if(ttl === 0) return "0.00"
    return ((val / ttl) * 100).toFixed(2)
}

type TtlCounterPanelProps = {
    counter: Counter
}
export default function TtlDeviceStatusCounterPanel({counter}: TtlCounterPanelProps) {
    return (
        <>
            <TtlDeviceStatusCounter count={counter.ttlCount} colorType="primary" label="총계"/>
            <TtlDeviceStatusCounter count={counter.normalCount} colorType="success" label="정상"
                                         percent={calculatePercent(counter.ttlCount, counter.normalCount)}/>
            <TtlDeviceStatusCounter count={counter.noneOperationCount} colorType="grey" label="미운행"
                                         percent={calculatePercent(counter.ttlCount, counter.noneOperationCount)}/>
            <TtlDeviceStatusCounter count={counter.errorCount} colorType="warning" label="점검"
                                         percent={calculatePercent(counter.ttlCount, counter.errorCount)}/>
            <TtlDeviceStatusCounter count={counter.emergencyCount} colorType="danger" label="긴급"
                                         percent={calculatePercent(counter.ttlCount, counter.emergencyCount)}/>
        </>
    )
}
type TtlCountViewProps = {
    count: number
    colorType: colorType
    percent?: number | string
    label: string
}

type colorType = "primary" | "info" | "success" | "warning" | "danger" | "light" | "dark" | "grey"

export function TtlDeviceStatusCounter({count = 0, colorType = "primary", percent, label = ""}: TtlCountViewProps) {
    return (
        <div className="column ">
            <div className="box p10">
                <div className="columns">
                    <div className="column">
                        <h5 className={`subtitle has-text-weight-semibold ml15 has-text-${colorType} mb5`}>
                            {label}
                        </h5>
                        <h5 className="title is-size-1 has-text-weight-bold  ml15 ">
                            {count.toLocaleString()}
                            <span className="is-size-5 ml10 has-text-grey-light">대</span>
                            {percent && <span className={`is-size-5 ml20 has-text-${colorType}`}>{percent}%</span>}
                        </h5>
                    </div>
                    <div className="column is-one-fifth has-text-right ">
                        <div className={`icon is-large has-background-${colorType} rounded-lg mt10 mr10`}>
                            <i className="fas fa-wheelchair fa-2x has-text-white"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}